
import Actions from '../constants/Actions';
import ContactMeStore from '../stores/ContactMeStore';

export async function saveLead(context, {lead}) {
  context.dispatch(Actions.CONTACT_LEAD_UPDATED, lead);
}

export async function saveZip(context, {form}) {
  context.dispatch(Actions.ZIPCODE_UPDATED, form);
}

export async function changeAppointmentFlow(context, {nextScreen}) {
  context.dispatch(Actions.CHANGE_CONTACT_SCREEN, nextScreen);
}

export async function mapLocationSelected(context, {location}) {
  context.dispatch(Actions.MAP_LOCATION_SELECTED, location);
}

export async function timeSlotSelected(context, time) {
  context.dispatch(Actions.APPOINTMENT_TIME_SELECTED, time);
}


/** WEBPACK FOOTER **
 ** ./src/main/js/contactMe/actions/ContactMeActionCreators.js
 **/